import request from '@/utils/request'

// 首页获取分类
export function ClassificationGetList(data) {
  return request({
    method: 'get',
    url: 'Classification/getList',
    params: data
  })
}
// 首页bannner图 Banner/getList
export function BannerGetList(data) {
  return request({
    method: 'get',
    url: 'Banner/getList',
    params: data
  })
}
// 预约参观
export function VisitAppointment(data) {
  return request({
    method: 'post',
    url: 'Visit_appointment/coruData',
    data: data
  })
}

// 获取页面第一屏图 Banner/getBanner
export function getBanner(data) {
  return request({
    method: 'get',
    url: 'Banner/getBanner',
    params: data
  })
}
// 学校概况 Profile/getList
export function Profile(data){
    return request({
        method:'get',
        url:'Profile/getList',
        params:data
    })
}

// 办学方略 Strategy/getList
export function Strategy(data){
    return request({
        method:'get',
        url:'Strategy/getList',
        params:data
    })
}

// 办学方略导航栏 Strategy_type/getList
export function Strategy_type(data){
  return request({
      method:'get',
      url:'Strategy_type/getList',
      params:data
  })
}

// 管理团队 Teacher/getList
export function Teacher(data){
  return request({
      method:'get',
      url:'Teacher/getList',
      params:data
  })
}

// 管理团队-顾问团队详情 Teacher/teacherDetails
export function teacherDetails(data){
  return request({
      method:'get',
      url:'Teacher/teacherDetails',
      params:data
  })
}

// 教师团队配置 Teacher_team/teacherConfigData
export function teacherConfigData(data){
  return request({
      method:'get',
      url:'Teacher_team/teacherConfigData',
      params:data
  })
}

// 部分名师介绍 Teacher_team/teacherTeamList
export function teacherTeamList(data){
  return request({
      method:'get',
      url:'Teacher_team/teacherTeamList',
      params:data
  })
}

// 老师团队详情 Teacher_team/teacherTeamDetails
export function teacherTeamDetails(data){
  return request({
      method:'get',
      url:'Teacher_team/teacherTeamDetails',
      params:data
  })
}

// 首页提示 Tips/tipsGteDetails
export function tipsGteDetails(data){
  return request({
      method:'get',
      url:'Tips/tipsGteDetails',
      params:data
  })
}


// WEBPACK FOOTER //
// ./src/api/home.js